<template>
    <div>
        <SignInH5/>
    </div>
</template>
<script>
    import SignInH5 from '../components/SignInH5';
    export default {
        name: 'Index',
        components: {
            SignInH5,
        },
    };
</script>